const SERVICE_MARKER = '__isRpcService__',
  assert = require('assert');

function interfaceClass(service) {
  const seed = typeof service === 'function' ? service.prototype : Object.getPrototypeOf(service);
  const result = find(seed).constructor;
  assert(result.prototype[SERVICE_MARKER], 'no interface found');
  return result;
}

function find(clazz) {
  if (!clazz.__proto__[SERVICE_MARKER]) {
    return clazz;
  } return find(clazz.__proto__);
}

function isRpcService(instance) {
  if (typeof instance === 'function') {
    return instance.prototype[SERVICE_MARKER] || false;
  } else {
    return instance && instance[SERVICE_MARKER] || false;
  }
}

function serviceMethods(service) {
  const clazz = interfaceClass(service);
  return Object.getOwnPropertyNames(clazz.prototype)
    .filter(prop => clazz.prototype[prop] && clazz.prototype[prop]._messageTypes)
    .map(name => ({name, messageTypes: clazz.prototype[name]._messageTypes(), __proto: clazz.prototype[name].__proto}));
}

const FQN = Symbol('fqn');
function fqn(type) {
  if (typeof type[FQN] === 'undefined') {
    let result = type.name;
    if (type.parent) {
      const parentFqn = fqn(type.parent);
      result = parentFqn.length > 0 ? `${parentFqn}.${result}` : result;
    }
    type[FQN] = result;
  }
  return type[FQN];
}

function unimplementedMethods(instanceOrClass) {
  const res = [];
  const iClass = interfaceClass(instanceOrClass);

  serviceMethods(instanceOrClass).forEach(({name}) => {
    if (typeof instanceOrClass === 'function') {
      if (iClass.prototype[name] === instanceOrClass.prototype[name]) {
        res.push(name);
      }
    } else {
      if (iClass.prototype[name] === instanceOrClass[name]) {
        res.push(name);
      }
    }
  });
  return res;
}

module.exports = {interfaceClass, serviceMethods, isRpcService, unimplementedMethods, fqn};
